<template>
  <div class="result-item _margin-bottom-30">
    <div class="result-item-container">
      <div class="review-badge badge" v-if="data.switchOption == 'None'">Review Only</div>

      <div class="row">
        <div class="col-sm-3">
          <div class="row _margin-bottom-20">
            <div class="col-xs-5">
              <supplier-logo :id="data.supplierId"></supplier-logo>
            </div>
            <div class="col-xs-7">
              <h6 class="_margin-bottom-0">{{ data.supplierName }}</h6>
              <p class="tariff-name">{{ data.tariffName }}</p>
            </div>
          </div>

          <div class="badge-group _margin-bottom-20">
            <span class="badge" v-if="data.isGreen">Green</span>
            <span class="badge" v-if="data.hasCancellationFee">Exit Fee</span>
            <span class="badge" v-if="data.isFixed">Fixed</span>
            <span class="badge" v-if="data.hasPaperBilling">Paper Billing</span>
            <span class="badge" v-if="data.hasOnlineManagement">Paperless Billing</span>
            <span class="badge">{{ data.hasWarmHomeDiscount ? 'Warm Home Discount' : 'No Warm Home Discount' }}</span>

            <span class="badge payment">{{ capitalize(data.payMethod) }}</span>
          </div>
        </div>

        <div class="col-sm-4">
          <ul class="bullet-points">
            <li v-for="(item, index) in limitTo(3, data.tariffDetails, this.moreTariffDetails)" :key="index">
              {{ item }}
            </li>
          </ul>

          <small v-if="data.tariffDetails.length === 0">No Tariff Details</small>

          <div class="text-left _margin-top-10" v-if="data.tariffDetails.length > 3">
            <uiv-btn type="default" size="xs" @click="toggleOpen('moreTariffDetails')">
              {{ data.tariffDetails.length - 3 }} {{ moreTariffDetails ? 'less' : 'more' }}
            </uiv-btn>
          </div>
        </div>

        <div class="col-sm-2 _margin-top-20">
          <div class="row pricing">
            <div class="col-xs-6 col-sm-12 _margin-bottom-10">
              <p>Projected Energy Cost</p>
              <h5>{{ data.totalCost | currency(2) }}<small>/year</small></h5>
            </div>

            <div class="col-xs-6 col-sm-12">
              <p>{{ data.savings > 0 ? 'Saving' : 'Increased Cost' }}</p>
              <h5 :class="{ red: data.savings < 0, green: data.savings > 0 }">
                {{ convertToPositive(data.savings) | currency(2)
                }}<small>/year</small></h5>
            </div>
          </div>
        </div>

        <div class="col-sm-3 _margin-top-20">
          <div class="row">
            <div class="col-xs-5">
              <uiv-btn type="link" class="action-button" block size="md" @click="$emit('onMore')">More Info</uiv-btn>
            </div>

            <div class="col-xs-7" v-if="data.switchOption != 'None'">
              <uiv-btn type="primary" block size="md" class="action-button" @click="$emit('onChoose')">
                Switch Now
              </uiv-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

export default {
  name: 'ResultItem',
  data() {
    return {
      moreTariffDetails: false,
      showBreakdown: false,
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      months: ['January', 'Feburary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
  },
  props: {
    data: Object,
    type: String,
    isTou: Boolean
  },
  methods: {
    async toggleOpen(prop) {
      this[prop] = !this[prop];

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: `Show ${this[prop] ? 'More' : 'Less'}` });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: this.data.tariffId });
      await this.$store.dispatch('tracing/saveActions');
    },
    limitTo(limit, array, toggle) {
      if (!toggle) {
        return array.slice(0, limit);
      }

      return array;
    },
    convertToPositive(number) {
      return number < 0 ? -1 * number : number;
    },
    active(from, to, prop) {
      const fromIndex = this[prop].indexOf(from);
      const toIndex = this[prop].indexOf(to);

      return this[prop].map((item, index) => ({
        from: index == fromIndex,
        to: index == toIndex,
        active: index >= fromIndex && index <= toIndex,
        name: this.formatLetters(item, prop == 'days' ? 1 : 3)
      }));
    },
    formatLetters(str, n) {
      return str.substring(0, n).toUpperCase();
    },
    capitalize(s) {
      if (!s) return '';
      return s.replace(/([A-Z])/g, ' $1').trim();
    }
  },
  components: {
    SupplierLogo
  }
};
</script>

<style lang="scss" src="./result-item.scss"></style>
